import React, { ChangeEvent, useContext } from "react";
import IOrder_Progress_State from "../../../../../models/IOrder_Progress_State";
import OrderStatesEnum from "../../../../../models/OrderStatesEnum";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwCheckbox from "../../../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwChips from "../../../../shared/OwChips/OwChips";
import ContextEnum from "../../../../../models/ContextEnum";
import ChipSizeEnum from "../../../../shared/OwChips/ChipSizeEnum";
import SupplierContext from "../../../../../contexts/SupplierContext";

type Props = {
    item: IOrder_Progress_State;
    selectedItems: IOrder_Progress_State[];
    updateOptionConfig: (e: ChangeEvent<any>, item: IOrder_Progress_State) => void;
    handlePdfEmailChange: (e: any, item: IOrder_Progress_State) => void;
    pdfPackingListEmails: { [key: number]: string };
    addEmail: (item: IOrder_Progress_State) => void;
    addPdfEmail: (item: IOrder_Progress_State) => void;
    updateItemEmails: (e: string | string[], item: IOrder_Progress_State) => void;
    updateItemPdfEmails: (e: string | string[], item: IOrder_Progress_State) => void;
    itemEmails: { [key: number]: string };
    handleChange: (e: any, item: IOrder_Progress_State) => void;
    hideHandle?: boolean;
};

export const OwWorkflowStateItem: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    // as a safety we want to make these not visible.
    // if (props.item.hideInWorkflowEditor) {
    //     return null;
    // }

    switch (props.item.order_state_id) {
        case OrderStatesEnum.PARTIALLY_SHIPPED:
        case OrderStatesEnum.SHIPPED:
        case OrderStatesEnum.PICKED_UP:
        case OrderStatesEnum.READY_FOR_PICKUP:
        case OrderStatesEnum.READY_FOR_DELIVERY:
        case OrderStatesEnum.DELIVERED:
        case OrderStatesEnum.READY_TO_SHIP:
            props.item.notMovable = true;
            break;
    }

    const isPreliminary = props.item.order_state_id === OrderStatesEnum.PRELIMINARY;

    let currentItemIndex = 0;
    let vendorROIndex = 0;
    let supplierUserROIndex = 0;
    let supplierAdminROIndex = 0;
    let allowRemakeROIndex = 0;
    let calculateShippingAtROIndex = 0;
    let collectPaymentsIndex = 0;
    let onlyAuthorizeIndex = 0;
    let completePaymentIndex = 0;
    let collectCcToUseIndex = 0;

    let i = 0;

    for (const state of props.selectedItems) {
        if (state.order_state_id === props.item.order_state_id) {
            currentItemIndex = i;
        }

        if (state.isVendorReadOnly) {
            vendorROIndex = i;
        }

        if (state.isSupplierReadOnly) {
            supplierUserROIndex = i;
        }

        if (state.isSupplierAdminReadOnly) {
            supplierAdminROIndex = i;
        }

        if (state.allowRemake) {
            allowRemakeROIndex = i;
        }

        if (state.calculateShippingAt) {
            calculateShippingAtROIndex = i;
        }

        if (state.collectPayment) {
            collectPaymentsIndex = i;
        }

        if (state.onlyAuthorize) {
            onlyAuthorizeIndex = i;
        }

        if (state.completePayment) {
            completePaymentIndex = i;
        }

        if (state.onlyCollectCcToUse) {
            collectCcToUseIndex = 1;
        }

        i++;
    }

    const isPreviouslyVendorReadOnly = vendorROIndex > 0 && vendorROIndex < currentItemIndex;
    const isPreviouslySupplierUserReadOnly = supplierUserROIndex > 0 && supplierUserROIndex < currentItemIndex;
    const isPreviouslySupplierAdminReadOnly = supplierAdminROIndex > 0 && supplierAdminROIndex < currentItemIndex;
    const isPreviouslyAllowRemake = allowRemakeROIndex > 0 && allowRemakeROIndex < currentItemIndex;
    const isPreviouslyCalculateShippingAt = calculateShippingAtROIndex > 0 && calculateShippingAtROIndex < currentItemIndex;
    const isPreviouslyCollectPayments = collectPaymentsIndex > 0 && collectPaymentsIndex < currentItemIndex;
    const isPreviouslyOnlyAuthorize = onlyAuthorizeIndex > 0 && onlyAuthorizeIndex < currentItemIndex;
    const isPreviouslyCompletePayment = completePaymentIndex > 0 && completePaymentIndex < currentItemIndex;
    const isPreviouslyCollectCcToUse = collectCcToUseIndex > 0 && collectCcToUseIndex < currentItemIndex;

    return (
        <div className={"OwWorkflowStateItem selectedItemWrapper"}>
            {props.hideHandle ? null : (
                <div className={"drag-handles"}>
                    <i className={"fas fa-grip-horizontal"}></i>
                </div>
            )}
            <div className={"title"}>
                <OwLabel title={props.item.name} noBottomMargin={true} />
            </div>
            {isPreliminary ? (
                <div className={"prelim-lock"}>
                    <i className={"fad fa-lock"} />
                </div>
            ) : null}
            {isPreliminary ? null : (
                <div className={"text-start"}>
                    {supplierModel.has_customer_module ? (
                        <div>
                            <OwCheckbox
                                label={"is_vendor_step"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.isVendorStep}
                                name={"isVendorStep"}
                                isSupplierVendorOverride={true}
                                supplierModel={supplierModel}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    <div>
                        <OwCheckbox
                            label={"is_admin_only_step"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.isAdminOnlyStep}
                            name={"isAdminOnlyStep"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    {supplierModel.has_customer_module ? (
                        <div>
                            <OwCheckbox
                                label={"is_vendor_read_only"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.isVendorReadOnly}
                                disabled={isPreviouslyVendorReadOnly}
                                mutedTextOnDisabled={true}
                                name={"isVendorReadOnly"}
                                isSupplierVendorOverride={true}
                                supplierModel={supplierModel}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    <div>
                        <OwCheckbox
                            label={"is_internal_user_read_only"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.isSupplierReadOnly}
                            disabled={isPreviouslySupplierUserReadOnly}
                            mutedTextOnDisabled={true}
                            name={"isSupplierReadOnly"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    <div>
                        <OwCheckbox
                            label={"is_internal_admin_read_only"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.isSupplierAdminReadOnly}
                            disabled={isPreviouslySupplierAdminReadOnly}
                            mutedTextOnDisabled={true}
                            name={"isSupplierAdminReadOnly"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    {supplierModel.has_payments ? (
                        <div>
                            <div>
                                <OwCheckbox
                                    label={"collect_payment"}
                                    truthyVal={true}
                                    falsyVal={false}
                                    checked={props.item.collectPayment}
                                    disabled={isPreviouslyCollectPayments}
                                    name={"collectPayment"}
                                    fn={(e: any) => {
                                        props.updateOptionConfig(e, props.item);
                                    }}
                                />
                            </div>
                            <div>
                                <OwCheckbox
                                    label={"only_collect_cc_to_use"}
                                    truthyVal={true}
                                    falsyVal={false}
                                    checked={props.item.onlyCollectCcToUse}
                                    disabled={isPreviouslyCollectCcToUse}
                                    name={"onlyCollectCcToUse"}
                                    fn={(e: any) => {
                                        props.updateOptionConfig(e, props.item);
                                    }}
                                />
                            </div>
                        </div>
                    ) : null}
                    {/*{false && collectPaymentsIndex > 0 && currentItemIndex >= collectPaymentsIndex ? (*/}
                    {/*    <div>*/}
                    {/*        <div>*/}
                    {/*            <OwCheckbox*/}
                    {/*                label={"only_authorize"}*/}
                    {/*                truthyVal={true}*/}
                    {/*                falsyVal={false}*/}
                    {/*                checked={props.item.onlyAuthorize}*/}
                    {/*                disabled={isPreviouslyOnlyAuthorize}*/}
                    {/*                name={"onlyAuthorize"}*/}
                    {/*                fn={(e: any) => {*/}
                    {/*                    props.updateOptionConfig(e, props.item);*/}
                    {/*                }}*/}
                    {/*            />*/}
                    {/*        </div>*/}

                    {/*        <div>*/}
                    {/*            <OwCheckbox*/}
                    {/*                label={"complete_payment"}*/}
                    {/*                truthyVal={true}*/}
                    {/*                falsyVal={false}*/}
                    {/*                checked={props.item.completePayment}*/}
                    {/*                disabled={isPreviouslyCompletePayment}*/}
                    {/*                name={"completePayment"}*/}
                    {/*                fn={(e: any) => {*/}
                    {/*                    props.updateOptionConfig(e, props.item);*/}
                    {/*                }}*/}
                    {/*            />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*) : null}*/}
                    {supplierModel.Supplier_Integration.has_taxjar ? (
                        <div>
                            <div>
                                <OwCheckbox
                                    label={"submit_order_to_taxjar"}
                                    truthyVal={true}
                                    falsyVal={false}
                                    checked={props.item.submitOrderToTaxJar}
                                    name={"submitOrderToTaxJar"}
                                    fn={(e: any) => {
                                        props.updateOptionConfig(e, props.item);
                                    }}
                                />
                            </div>
                        </div>
                    ) : null}
                    {supplierModel.has_remakes ? (
                        <div>
                            <OwCheckbox
                                label={"allow_remake"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.allowRemake}
                                disabled={isPreviouslyAllowRemake}
                                name={"allowRemake"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.has_service_levels || supplierModel.has_lead_times ? (
                        <div>
                            <OwCheckbox
                                label={"calculate_shipping_at"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.calculateShippingAt}
                                disabled={isPreviouslyCalculateShippingAt}
                                name={"calculateShippingAt"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.has_commissions ? (
                        <div>
                            <OwCheckbox
                                label={"release_commission"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.releaseCommission}
                                name={"releaseCommission"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.Supplier_Integration.has_woocommerce ? (
                        <div>
                            <OwCheckbox
                                label={"create_woocommerce_order"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.createOrderInWooCommerce}
                                name={"createOrderInWooCommerce"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.Supplier_Integration.has_qbo ? (
                        <div>
                            <OwCheckbox
                                label={"create_qbo_invoice"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.autoCreateQBOInvoice}
                                name={"autoCreateQBOInvoice"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.Supplier_Integration.has_qbo && props.item.autoCreateQBOInvoice ? (
                        <div>
                            <OwCheckbox
                                label={"auto_email_invoice"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.autoEmailQBOInvoice}
                                name={"autoEmailQBOInvoice"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.Supplier_Integration.has_qbd ? (
                        <div>
                            <OwCheckbox
                                label={"auto_queue_qbd_sales_order"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.autoQueueSalesOrderForQBD}
                                name={"autoQueueSalesOrderForQBD"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.Supplier_Integration.has_qbd ? (
                        <div>
                            <OwCheckbox
                                label={"auto_queue_qbd_invoice"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.autoQueueInvoiceForQBD}
                                name={"autoQueueInvoiceForQBD"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.has_shipments ? (
                        <div>
                            <OwCheckbox
                                label={"allow_create_fulfillment"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.allowCreateFulfillment}
                                name={"allowCreateFulfillment"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.has_serials ? (
                        <div>
                            <OwCheckbox
                                label={"require_serials_assigned"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.requireSerialsAssigned}
                                name={"requireSerialsAssigned"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.has_customer_module ? (
                        <div>
                            <OwCheckbox
                                label={"alert_vendor"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.alertVendor}
                                name={"alertVendor"}
                                isSupplierVendorOverride={true}
                                supplierModel={supplierModel}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {isPreviouslySupplierAdminReadOnly || isPreviouslySupplierUserReadOnly ? (
                        <div>
                            <OwCheckbox
                                label={"allow_file_upload"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.allowFileUploadIfReadOnly}
                                name={"allowFileUploadIfReadOnly"}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    <div>
                        <OwCheckbox
                            label={"send_email"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.sendEmail}
                            name={"sendEmail"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    <div>
                        <OwCheckbox
                            disabled={!props.item.sendEmail}
                            label={"email_internally"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.email_supplier}
                            name={"email_supplier"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    <div>
                        <OwCheckbox
                            disabled={!props.item.sendEmail}
                            label={"email_user"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.email_user}
                            name={"email_user"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    {supplierModel.send_vendor_emails ? (
                        <div>
                            <OwCheckbox
                                disabled={!props.item.sendEmail}
                                label={"email_vendor"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.email_vendor}
                                name={"email_vendor"}
                                isSupplierVendorOverride={true}
                                supplierModel={supplierModel}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {supplierModel.has_client_module ? (
                        <div>
                            <OwCheckbox
                                disabled={!props.item.sendEmail}
                                label={"email_client"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.email_client}
                                name={"email_client"}
                                isSupplierVendorOverride={true}
                                supplierModel={supplierModel}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {props.item && supplierModel.has_rep_groups ? (
                        <div>
                            <OwCheckbox
                                disabled={!props.item.sendEmail}
                                label={"email_rep_group"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.email_rep_group}
                                name={"email_rep_group"}
                                isSupplierVendorOverride={true}
                                supplierModel={supplierModel}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    {props.item && supplierModel.has_catalog_email ? (
                        <div>
                            <OwCheckbox
                                disabled={!props.item.sendEmail}
                                label={"email_catalog_email"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={props.item.email_catalog_email}
                                name={"email_catalog_email"}
                                isSupplierVendorOverride={true}
                                supplierModel={supplierModel}
                                fn={(e: any) => {
                                    props.updateOptionConfig(e, props.item);
                                }}
                            />
                        </div>
                    ) : null}
                    <div>
                        <OwCheckbox
                            disabled={!props.item.sendEmail}
                            label={"attach_order_csv"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.attachOrderCsv}
                            name={"attachOrderCsv"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    <div>
                        <OwCheckbox
                            disabled={!props.item.sendEmail}
                            label={"attach_order_pdf"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.attachOrderPdf}
                            name={"attachOrderPdf"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    <div>
                        <OwCheckbox
                            disabled={!props.item.sendEmail}
                            label={"attach_packing_list_pdf"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.attachPackingListPdf}
                            name={"attachPackingListPdf"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    <div>
                        <OwCheckbox
                            disabled={!props.item.sendEmail}
                            label={"allow_custom_message"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.allowCustomMessage}
                            name={"allowCustomMessage"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                    </div>
                    <div>
                        <OwCheckbox
                            label={"email_pdf_packing_list"}
                            truthyVal={true}
                            falsyVal={false}
                            checked={props.item.emailPDFPackingList}
                            name={"emailPDFPackingList"}
                            fn={(e: any) => {
                                props.updateOptionConfig(e, props.item);
                            }}
                        />
                        {!props.item.emailPDFPackingList ? null : (
                            <div className={"mt-2"}>
                                <div>
                                    <OwLabel title={"pdf_packing_list_emails"} noBottomMargin={true} />
                                </div>
                                <div className={"input-group mb-2"}>
                                    <OwInputWrapper
                                        placeholder={"email"}
                                        name={"pdfPackingListEmails"}
                                        fn={(e: any) => {
                                            props.handlePdfEmailChange(e, props.item);
                                        }}
                                        value={props.pdfPackingListEmails[props.item.order_state_id]}
                                    />
                                    <div className={"input-group-append"}>
                                        <OwButton
                                            title={"add"}
                                            fn={(e) => {
                                                props.addPdfEmail(props.item);
                                            }}
                                        />
                                    </div>
                                </div>

                                {props.item.emailPDFPackingListTo ? (
                                    <OwChips
                                        chips={props.item.emailPDFPackingListTo}
                                        updatedFn={(e) => {
                                            props.updateItemPdfEmails(e, props.item);
                                        }}
                                        context={ContextEnum.PRIMARY}
                                        isStacked={true}
                                        chipSize={ChipSizeEnum.XS}
                                    />
                                ) : null}
                            </div>
                        )}
                    </div>
                    <div className={"mt-2"}>
                        <div>
                            <OwLabel title={"addl_email"} noBottomMargin={true} />
                        </div>
                        <div className={"input-group mb-2"}>
                            <OwInputWrapper
                                disabled={!props.item.sendEmail}
                                placeholder={"email"}
                                name={"email"}
                                fn={(e: any) => {
                                    props.handleChange(e, props.item);
                                }}
                                value={props.itemEmails[props.item.order_state_id]}
                            />
                            <OwButton
                                title={"add"}
                                fn={(e) => {
                                    props.addEmail(props.item);
                                }}
                            />
                        </div>

                        {props.item.email ? (
                            <OwChips
                                chips={props.item.email}
                                updatedFn={(e) => {
                                    props.updateItemEmails(e, props.item);
                                }}
                                context={ContextEnum.PRIMARY}
                                isStacked={true}
                                chipSize={ChipSizeEnum.XS}
                            />
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    );
};
